(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6293],{

/***/ 98041:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/disease-encyclopedia",
      function () {
        return __webpack_require__(89943);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 27441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(89961);
/* harmony import */ var _components_atom_icon_Arrow_BreadCrumbArrow__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22522);
/* harmony import */ var _constants_url__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26093);
/* harmony import */ var _constants_zIndex__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31591);
/* harmony import */ var _styles_layout__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(64952);
/* harmony import */ var _types_common__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70138);
/* harmony import */ var _types_magazine__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45162);
/* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(78287);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  color: ",
        ";\n  visibility: ",
        ";\n  position: ",
        ";\n  display: flex;\n\n  @media screen and (max-width: ",
        ") {\n    ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  svg {\n    margin: 0 2px;\n  }\n  p:hover {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 24px 24px 0;\n  position: relative;\n  z-index: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}












var BreadCrumbs = function(param) {
    var visible = param.visible, path = param.path, type = param.type, name = param.name, urlParameter = param.urlParameter;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var paths = path.split("/").filter(function(item) {
        return item !== "content";
    });
    var breadCrumbPath = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function(detailPath) {
        if (detailPath === "") {
            return {
                label: "홈",
                url: "/",
                logName: "home"
            };
        }
        if (path.includes("community")) {
            if (detailPath === "setting") {
                return {
                    label: "설정",
                    url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.COMMUNITY.SETTING.path */ .Z6.COMMUNITY.SETTING.path),
                    logName: "community_setting"
                };
            }
            if (detailPath === "write") {
                return {
                    label: "글쓰기",
                    url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.COMMUNITY.WRITE.path */ .Z6.COMMUNITY.WRITE.path),
                    logName: "community_write"
                };
            }
            if (detailPath === "comment") {
                var pid = path.split("/");
                return {
                    label: "대댓글",
                    url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.COMMUNITY.COMMENT.path */ .Z6.COMMUNITY.COMMENT.path, "/").concat(pid[pid.length - 1]),
                    logName: "community_comment"
                };
            }
            if (detailPath === "community") {
                return {
                    label: "커뮤니티",
                    url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.COMMUNITY.LIST.path */ .Z6.COMMUNITY.LIST.path),
                    logName: "community_list"
                };
            }
            if (detailPath === "list") {
                return {
                    label: name,
                    url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.COMMUNITY.LIST.path */ .Z6.COMMUNITY.LIST.path).concat(urlParameter),
                    logName: "community_list_category"
                };
            }
        }
        if (detailPath === "qna") {
            return {
                label: "실시간 의료상담",
                url: _types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.QNA.REALTIME.path */ .Z6.QNA.REALTIME.path,
                logName: "qna_list"
            };
        }
        if (detailPath === "realtime") {
            return {
                label: name,
                url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.QNA.REALTIME.path */ .Z6.QNA.REALTIME.path).concat(urlParameter),
                logName: "qna_list_category"
            };
        }
        if (detailPath === "write") {
            return {
                label: "질문 작성",
                url: _types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.QNA.WRITE.path */ .Z6.QNA.WRITE.path,
                logName: "qna_write"
            };
        }
        if (detailPath === "nps") {
            return {
                label: "의견 전하기",
                url: _types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.QNA.NPS.path */ .Z6.QNA.NPS.path,
                logName: "qna_nps"
            };
        }
        if (path.includes("author")) {
            if (detailPath === "author") {
                return {
                    label: "에디터",
                    url: _types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.MAGAZINE.HOME.path */ .Z6.MAGAZINE.HOME.path,
                    logName: "magazine_list"
                };
            }
            return {
                label: name,
                url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.AUTHOR.DETAIL.path */ .Z6.AUTHOR.DETAIL.path, "/").concat(urlParameter),
                logName: "magazine_list"
            };
        }
        if (path.includes("magazine")) {
            if (detailPath === "magazine") {
                return {
                    label: "건강 매거진",
                    url: _constants_url__WEBPACK_IMPORTED_MODULE_6__/* .Urls.Magazine */ .n.Magazine,
                    logName: "magazine_list"
                };
            }
            return {
                label: name,
                url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.MAGAZINE.DETAIL.path */ .Z6.MAGAZINE.DETAIL.path, "/").concat(urlParameter),
                logName: "magazine_list"
            };
        }
        if (path.includes("faq")) {
            if (detailPath === "faq") {
                return {
                    label: "1분 FAQ",
                    url: _types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.FAQ.LIST.path */ .Z6.FAQ.LIST.path,
                    logName: "faq_list"
                };
            }
            return {
                label: name,
                url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.FAQ.DETAIL.path */ .Z6.FAQ.DETAIL.path, "/").concat(urlParameter),
                logName: "faq_list"
            };
        }
        if (detailPath === "mypage") {
            return {
                label: "마이페이지",
                url: _types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.COMMON.MYPAGE.path */ .Z6.COMMON.MYPAGE.path,
                logName: "mypage"
            };
        }
        if (path.includes("hospitals")) {
            if (detailPath.includes("search")) {
                return {
                    label: "검색 결과",
                    url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.HOSPITAL.DETAIL.path */ .Z6.HOSPITAL.DETAIL.path).concat(detailPath),
                    logName: "hospitals_search"
                };
            }
            if (detailPath.includes("sub-category")) {
                return {
                    label: "검색 결과",
                    url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.HOSPITAL.HOME.path */ .Z6.HOSPITAL.HOME.path, "/").concat(detailPath),
                    logName: "hospitals_subcategory"
                };
            }
            if (detailPath.includes("neighborhood")) {
                return {
                    label: "지역별 병원 정보",
                    url: path,
                    logName: "hospitals_neighborhood"
                };
            }
            return {
                label: "병원 찾기",
                url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.HOSPITAL.HOME.path */ .Z6.HOSPITAL.HOME.path),
                logName: "hospitals"
            };
        }
        if (path.includes("medicine-dictionary")) {
            if (detailPath === "search") {
                return {
                    label: "검색 결과",
                    url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.MEDICINE_DICTIONARY.SEARCH.path */ .Z6.MEDICINE_DICTIONARY.SEARCH.path),
                    logName: "medicine_dictionary_search_result"
                };
            }
            return {
                label: "의약품 사전",
                url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.MEDICINE_DICTIONARY.HOME.path */ .Z6.MEDICINE_DICTIONARY.HOME.path),
                logName: "medicine_dictionary_list"
            };
        }
        if (path.includes("disease-encyclopedia")) {
            if (detailPath === "select-subject") {
                return {
                    label: "과목 선택",
                    url: _types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.DISEASE_ENCYCLOPEDIA.SELECT_SUBJECT.path */ .Z6.DISEASE_ENCYCLOPEDIA.SELECT_SUBJECT.path,
                    logName: "disease_encyclopedia_select_subject"
                };
            }
            if (detailPath === "total") {
                return {
                    label: "전체 질환",
                    url: _types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.DISEASE_ENCYCLOPEDIA.SELECT_SUBJECT.path */ .Z6.DISEASE_ENCYCLOPEDIA.SELECT_SUBJECT.path,
                    logName: "disease_encyclopedia_select_subject"
                };
            }
            if (detailPath === "search") {
                return {
                    label: "검색 결과",
                    url: _types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.DISEASE_ENCYCLOPEDIA.SEARCH.path */ .Z6.DISEASE_ENCYCLOPEDIA.SEARCH.path,
                    logName: "disease_encyclopedia_search"
                };
            }
            return {
                label: "질환백과",
                url: _types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.DISEASE_ENCYCLOPEDIA.HOME.path */ .Z6.DISEASE_ENCYCLOPEDIA.HOME.path,
                logName: "disease_encyclopedia_list"
            };
        }
        if (detailPath === "search") {
            return {
                label: "통합검색",
                url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.SEARCH */ .Z6.SEARCH().HOME.path),
                logName: "integrated_search"
            };
        }
        if (detailPath === "list") {
            return {
                label: "전체",
                url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.MAGAZINE.LIST.path */ .Z6.MAGAZINE.LIST.path, "/").concat(_types_magazine__WEBPACK_IMPORTED_MODULE_9__/* .MagazineType.INTERNAL */ .rL.INTERNAL),
                logName: "magazine_list"
            };
        }
        if (detailPath.includes("tag")) {
            var tag = detailPath.split("=");
            return {
                label: decodeURI(tag[1]),
                url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.MAGAZINE.HOME.path */ .Z6.MAGAZINE.HOME.path, "/").concat(detailPath),
                logName: "magazine_list_tags"
            };
        }
        if (detailPath === "non-benefit") {
            return {
                label: "우리동네 진료 가격",
                url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.NON_BENEFIT.HOME.path */ .Z6.NON_BENEFIT.HOME.path),
                logName: "non_benefit_home"
            };
        }
        if (detailPath.includes("map")) {
            return {
                label: "최저가 약국 찾기",
                url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.NON_BENEFIT.MAP.path */ .Z6.NON_BENEFIT.MAP.path),
                logName: "non_benefit_map"
            };
        }
        if (name) {
            return {
                label: name,
                url: type === "qna" ? "".concat(_constants_url__WEBPACK_IMPORTED_MODULE_6__/* .Urls.QnaCategory */ .n.QnaCategory, "/").concat(detailPath) : "".concat(_constants_url__WEBPACK_IMPORTED_MODULE_6__/* .Urls.MagazineCategory */ .n.MagazineCategory, "/list/").concat(detailPath),
                logName: "ctg"
            };
        }
        return {
            label: decodeURI(decodeURIComponent(detailPath)),
            url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.MAGAZINE.LIST.path */ .Z6.MAGAZINE.LIST.path, "/").concat(detailPath),
            logName: "magazine_list_tags"
        };
    }, [
        name,
        path,
        type
    ]);
    var breadCrumb = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        return paths.map(function(path) {
            return breadCrumbPath(path);
        }).filter(function(item) {
            return item !== null;
        });
    }, [
        breadCrumbPath,
        paths
    ]);
    var onClickBreadCrumb = function(name) {
        (0,_utils_logger__WEBPACK_IMPORTED_MODULE_10__/* .logger */ .kg)({
            pageName: (0,_utils_logger__WEBPACK_IMPORTED_MODULE_10__/* .getPageName */ .j0)(router),
            eventName: "breadcrumb_".concat(name, "_click")
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        visible: visible,
        id: "breadcrumbs",
        children: breadCrumb.map(function(item, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Path, {
                role: "button",
                onClick: function() {
                    return onClickBreadCrumb(item.logName);
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: item.url,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                children: item.label
                            })
                        })
                    }),
                    index !== breadCrumb.length - 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_icon_Arrow_BreadCrumbArrow__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
                ]
            }, item.label);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BreadCrumbs);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-aec17bfc-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.typography.UI13M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray400;
}, function(param) {
    var visible = param.visible;
    return visible ? "visible" : "hidden";
}, function(param) {
    var visible = param.visible;
    return visible ? "static" : "absolute";
}, _styles_layout__WEBPACK_IMPORTED_MODULE_12__/* .Tablet */ .YD, function(param) {
    var theme = param.theme;
    return theme.typography.UI14R;
});
var Path = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-aec17bfc-1"
})(_templateObject1());
var BreadCrumbsWrapper = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-aec17bfc-2"
})(_templateObject2(), _constants_zIndex__WEBPACK_IMPORTED_MODULE_7__/* .zIndex.BreadCrumb */ .W.BreadCrumb);
BreadCrumbs.Wrapper = BreadCrumbsWrapper;


/***/ }),

/***/ 22522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var BreadCrumbArrow = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.557 2.67311C5.43361 2.69613 5.32045 2.77137 5.25001 2.87723C5.20047 2.95168 5.17989 3.01695 5.17636 3.11082C5.17199 3.22681 5.19204 3.30295 5.25091 3.39399C5.26614 3.41752 5.75502 3.90878 7.5576 5.71185L9.84498 7.99985L7.5576 10.2879C5.75502 12.0909 5.26614 12.5822 5.25091 12.6057C5.19204 12.6968 5.17199 12.7729 5.17636 12.8889C5.17896 12.9579 5.18893 13.0034 5.21347 13.0579C5.26381 13.1698 5.37402 13.27 5.49032 13.3095C5.59721 13.3459 5.73841 13.3389 5.83633 13.2924C5.92155 13.2519 5.7554 13.4152 8.27956 10.891C9.62615 9.54438 10.6303 8.537 10.6468 8.51612C10.8436 8.26702 10.882 7.92846 10.7457 7.64359C10.7179 7.58549 10.6842 7.53099 10.6468 7.48359C10.6303 7.46271 9.62615 6.45533 8.27956 5.10871C6.23381 3.06291 5.93645 2.76711 5.90463 2.74629C5.82035 2.69112 5.75534 2.67081 5.65514 2.66833C5.61039 2.66722 5.58087 2.66866 5.557 2.67311Z",
            fill: "#A9AEB1"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BreadCrumbArrow);


/***/ }),

/***/ 26093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ Urls; },
/* harmony export */   "s": function() { return /* binding */ OutLinks; }
/* harmony export */ });
/**
 * @deprecated
 * 외부 링크 -> OutLinks
 * 내부 링크 -> types/common.ts
 */ var Urls = {
    Introduce: "/",
    Qna: "/content/qna",
    QnaCategory: "/content/qna/category",
    QnaWrite: "/content/qna/write",
    QnaWriteComplete: "/content/qna/write/complete",
    Magazine: "/content/magazine",
    MagazineCategory: "/content/magazine/category",
    MagazineTag: "/content/magazine/tag",
    MyPage: "/content/mypage",
    Hospital: "/hospitals",
    Error: "/content/error"
};
var OutLinks = {
    Contact: "https://company.doctornow.co.kr/contact/",
    Service: "https://company.doctornow.co.kr/service",
    Notice: "https://company.doctornow.co.kr/notice",
    Career: "https://company.doctornow.co.kr/career",
    Company: "https://company.doctornow.co.kr/company",
    Culture: "https://company.doctornow.co.kr/culture",
    Partnership: "https://company.doctornow.co.kr/partnership",
    StockConfirmInfo: "https://company.doctornow.co.kr/%eb%82%98%ec%9a%b0%ec%95%bd%ea%b5%ad-%ed%99%8d"
};


/***/ }),

/***/ 18103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F9": function() { return /* binding */ DiseaseEncyclopediaFaqModel; },
/* harmony export */   "Q8": function() { return /* binding */ EDiseaseEncyclopediaBottomButtonType; },
/* harmony export */   "p6": function() { return /* binding */ DiseaseEncyclopediaBannerModel; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90581);

var EDiseaseEncyclopediaBottomButtonType;
(function(EDiseaseEncyclopediaBottomButtonType) {
    EDiseaseEncyclopediaBottomButtonType["DiagnosisReservation"] = "DIAGNOSIS_RESERVATION";
    EDiseaseEncyclopediaBottomButtonType["None"] = "NONE";
    EDiseaseEncyclopediaBottomButtonType["Qna"] = "QNA";
})(EDiseaseEncyclopediaBottomButtonType || (EDiseaseEncyclopediaBottomButtonType = {}));
var DiseaseEncyclopediaBannerModel = function DiseaseEncyclopediaBannerModel(data) {
    "use strict";
    var _this = this;
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, DiseaseEncyclopediaBannerModel);
    this.getButtonPhrase = function() {
        return _this.buttonPhrase;
    };
    this.getDescription = function() {
        return _this.description;
    };
    this.getExternalUrl = function() {
        return _this.externalUrl;
    };
    this.getImageUrl = function() {
        return _this.imageUrl;
    };
    this.getTitle = function() {
        return _this.title;
    };
    this.buttonPhrase = data.buttonPhrase;
    this.description = data.description;
    this.externalUrl = data.externalUrl;
    this.imageUrl = data.imageUrl;
    this.title = data.title;
};
var DiseaseEncyclopediaFaqModel = function DiseaseEncyclopediaFaqModel(data) {
    "use strict";
    var _this = this;
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, DiseaseEncyclopediaFaqModel);
    this.getQuestion = function() {
        return _this.question;
    };
    this.getAnswer = function() {
        return _this.answer;
    };
    this.question = data.question;
    this.answer = data.answer;
};
var DiseaseEncyclopediaModel = function DiseaseEncyclopediaModel(data) {
    "use strict";
    var _this = this;
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, DiseaseEncyclopediaModel);
    this.getDepartmentTags = function() {
        var _departmentTags;
        return (_departmentTags = _this.departmentTags) !== null && _departmentTags !== void 0 ? _departmentTags : [];
    };
    this.getJoinedDepartmentTags = function() {
        var ref;
        var ref1;
        return (ref1 = (ref = _this.departmentTags) === null || ref === void 0 ? void 0 : ref.join(", ")) !== null && ref1 !== void 0 ? ref1 : "";
    };
    this.getSearchTags = function() {
        var _searchTags;
        return (_searchTags = _this.searchTags) !== null && _searchTags !== void 0 ? _searchTags : [];
    };
    this.getSymptomTags = function() {
        var _symptomTags;
        return (_symptomTags = _this.symptomTags) !== null && _symptomTags !== void 0 ? _symptomTags : [];
    };
    this.getJoinedSymptomTags = function() {
        var ref;
        var ref1;
        return (ref1 = (ref = _this.symptomTags) === null || ref === void 0 ? void 0 : ref.join(", ")) !== null && ref1 !== void 0 ? ref1 : "";
    };
    this.getPublicId = function() {
        return _this.publicId;
    };
    this.getTitle = function() {
        return _this.title;
    };
    this.getTitleImageUrl = function() {
        var _titleImageUrl;
        return (_titleImageUrl = _this.titleImageUrl) !== null && _titleImageUrl !== void 0 ? _titleImageUrl : null;
    };
    this.getContent = function() {
        return _this.content;
    };
    this.getBanner = function() {
        return _this.banner;
    };
    this.getBottomButtonType = function() {
        return _this.bottomButtonType;
    };
    this.getFaqs = function() {
        var _faqs;
        return (_faqs = _this.faqs) !== null && _faqs !== void 0 ? _faqs : [];
    };
    this.id = data.id;
    this.publicId = data.publicId;
    this.bottomButtonType = data.bottomButtonType;
    this.content = data.content;
    this.departmentTags = data.departmentTags;
    this.searchTags = data.searchTags;
    this.title = data.title;
    this.titleImageUrl = data.titleImageUrl;
    this.symptomTags = data.symptomTags;
    this.banner = data.banner;
    this.faqs = data.faqs;
};
/* harmony default export */ __webpack_exports__["ZP"] = (DiseaseEncyclopediaModel);


/***/ }),

/***/ 1598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$f": function() { return /* binding */ createDiseaseEncyclopediaDetailUrl; },
/* harmony export */   "mR": function() { return /* binding */ createDiseaseEncyclopediaDetailUrlWithKeyword; }
/* harmony export */ });
/* unused harmony export createDiseaseEncyclopediaRedirectUrl */
/* harmony import */ var _shared_utils_format__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64214);
/* harmony import */ var _types_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70138);


var createDiseaseEncyclopediaDetailUrl = function(diseaseEncyclopedia) {
    if (!diseaseEncyclopedia) {
        return "";
    }
    var publicId = diseaseEncyclopedia.getPublicId();
    var keyword = diseaseEncyclopedia.getTitle();
    return createDiseaseEncyclopediaDetailUrlWithKeyword(publicId, keyword);
};
var createDiseaseEncyclopediaDetailUrlWithKeyword = function(publicId, keyword) {
    var formattedKeyword = (0,_shared_utils_format__WEBPACK_IMPORTED_MODULE_1__/* .formatKeywordForUrl */ .Z)(keyword);
    var encodedKeyword = encodeURIComponent(formattedKeyword);
    return "".concat(_types_common__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.DISEASE_ENCYCLOPEDIA.DETAIL.path */ .Z6.DISEASE_ENCYCLOPEDIA.DETAIL.path, "/").concat(publicId, "/").concat(encodedKeyword);
};
var extractKeywordFromDiseaseEncyclopediaData = function(diseaseEncyclopedia) {
    var ref;
    return (ref = diseaseEncyclopedia === null || diseaseEncyclopedia === void 0 ? void 0 : diseaseEncyclopedia.title) !== null && ref !== void 0 ? ref : "";
};
var createDiseaseEncyclopediaRedirectUrl = function(publicId, diseaseEncyclopedia) {
    var keyword = extractKeywordFromDiseaseEncyclopediaData(diseaseEncyclopedia);
    return createDiseaseEncyclopediaDetailUrlWithKeyword(publicId, keyword);
};


/***/ }),

/***/ 76122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "lE": function() { return /* binding */ useGetDiagnosisCategoriesV2Query; },
/* harmony export */   "ze": function() { return /* binding */ useSearchDoctorsByUserQuery; }
/* harmony export */ });
/* unused harmony exports SearchDoctorsByUserDocument, GetDiagnosisCategoriesV2Document */
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36492);
/* harmony import */ var _utils_fetcher__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8391);


var SearchDoctorsByUserDocument = "\n    query SearchDoctorsByUser($request: DoctorSearchByUserRequestInput!) {\n  searchDoctorsByUser(request: $request) {\n    totalCount\n    items {\n      createdAt\n      hospitalName\n      id\n      publicId\n      isAffiliated\n      medicineType\n      name\n      profileUrl\n      medicineType\n      professionalDepartment {\n        name\n      }\n      readyForVideoCall\n      reviewAverageRating\n      reviewCount\n      bookingInfo {\n        bookingAvailability\n        isBookable\n        todayBookable\n        todayCutoffTime\n        todayKickoffTime\n        todaySchedule\n        tomorrowBookable\n        tomorrowCutoffTime\n        tomorrowKickoffTime\n        tomorrowSchedule\n      }\n    }\n  }\n}\n    ";
var useSearchDoctorsByUserQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "SearchDoctorsByUser",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(SearchDoctorsByUserDocument, "SearchDoctorsByUser", variables), options);
};
useSearchDoctorsByUserQuery.getKey = function(variables) {
    return [
        "SearchDoctorsByUser",
        variables
    ];
};
useSearchDoctorsByUserQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(SearchDoctorsByUserDocument, "SearchDoctorsByUser", variables, options);
};
var GetDiagnosisCategoriesV2Document = "\n    query GetDiagnosisCategoriesV2($contactType: DiagnosisContactType!) {\n  getDiagnosisCategoriesV2(contactType: $contactType) {\n    popularDepartmentCategories {\n      id\n      name\n    }\n    departmentCategories {\n      id\n      name\n      iconUrl\n      description\n    }\n    popularTreatmentCategories {\n      id\n      name\n    }\n    treatmentCategories {\n      id\n      name\n      iconUrl\n      items {\n        id\n        name\n      }\n    }\n  }\n}\n    ";
var useGetDiagnosisCategoriesV2Query = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "GetDiagnosisCategoriesV2",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetDiagnosisCategoriesV2Document, "GetDiagnosisCategoriesV2", variables), options);
};
useGetDiagnosisCategoriesV2Query.getKey = function(variables) {
    return [
        "GetDiagnosisCategoriesV2",
        variables
    ];
};
useGetDiagnosisCategoriesV2Query.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetDiagnosisCategoriesV2Document, "GetDiagnosisCategoriesV2", variables, options);
};


/***/ }),

/***/ 60643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ telemedicine_useGetDiagnosisCategories; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ./src/hooks/telemedicine/telemedicine.gql.impl.tsx
var telemedicine_gql_impl = __webpack_require__(76122);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27805);
;// CONCATENATED MODULE: ./src/models/diagnosis/category.ts


var DepartmentCategoryModel = /*#__PURE__*/ function() {
    "use strict";
    function DepartmentCategoryModel(id, name, description, icon) {
        (0,_class_call_check/* default */.Z)(this, DepartmentCategoryModel);
        this.id = id;
        this.name = name;
        this.description = description;
        this.icon = icon;
    }
    var _proto = DepartmentCategoryModel.prototype;
    _proto.getSeoTitle = function getSeoTitle() {
        switch(this.id){
            case "2":
                return "소아과(소아청소년과) 비대면 진료 | 아이 감기\xb7열\xb7기침 진료 - 닥터나우";
            default:
                return "".concat(this.name, " 비대면 진료 | 진료과\xb7질환별 원격진료 - 닥터나우");
        }
    };
    _proto.getSeoDescription = function getSeoDescription() {
        switch(this.id){
            case "2":
                return "아이가 아플 때 빠르게 소아과 진료를 받고 싶다면? 닥터나우에서 의사와 실시간 비대면진료 후 비대면 약 처방받아 보세요.";
            default:
                return "".concat(this.name, "에 맞는 의사를 빠르게 찾고, 병원 방문 없이 비대면진료로 약 처방까지 받아보세요.");
        }
    };
    _proto.getKeywords = function getKeywords() {
        switch(this.id){
            case "2":
                return "소아청소년과, 소아과 비대면 진료, 아기 감기, 기침, 열, 소아과약, 처방";
            default:
                return "비대면진료, 원격진료, 온라인진료, 비대면처방, 약처방, 약배송, 약배달, 진료비";
        }
    };
    return DepartmentCategoryModel;
}();
var PopularDepartmentCategoryModel = function PopularDepartmentCategoryModel(id, name) {
    "use strict";
    (0,_class_call_check/* default */.Z)(this, PopularDepartmentCategoryModel);
    this.id = id;
    this.name = name;
};
var PopularTreatmentCategoryModel = function PopularTreatmentCategoryModel(id, name) {
    "use strict";
    (0,_class_call_check/* default */.Z)(this, PopularTreatmentCategoryModel);
    this.id = id;
    this.name = name;
};
var TreatmentCategoryModel = /*#__PURE__*/ function() {
    "use strict";
    function TreatmentCategoryModel(id, name, icon, _treatments) {
        (0,_class_call_check/* default */.Z)(this, TreatmentCategoryModel);
        this.id = id;
        this.name = name;
        this.icon = icon;
        this._treatments = _treatments;
    }
    var _proto = TreatmentCategoryModel.prototype;
    _proto.getSeoTitle = function getSeoTitle(treatmentId) {
        switch(treatmentId){
            case "1":
                return "감기\xb7독감 비대면 진료 | 병원 방문 없이 처방받는 닥터나우";
            case "558":
                return "인공눈물 처방 | 안구건조증 비대면 진료 - 닥터나우";
            case "9":
                return "탈모약 비대면 진료 | 피나스테리드\xb7두타스테리드 처방 - 닥터나우";
            case "11":
                return "여드름약 비대면 진료 | 항생제\xb7외용제 빠른 처방 - 닥터나우";
            default:
                return "".concat(this.name, " 비대면 진료 | 진료과\xb7질환별 원격진료 - 닥터나우");
        }
    };
    _proto.getSeoDescription = function getSeoDescription(treatmentId) {
        switch(treatmentId){
            case "1":
                return "코감기, 인후통, 몸살 증상이 있으신가요? 병원 갈 필요 없이 닥터나우에서 의사와 비대면 진료 후 약 처방받아 보세요.";
            case "558":
                return "눈이 뻑뻑하고 피로하다면? 안과 갈 필요 없이 닥터나우에서 인공눈물, 안구건조증 치료제를 비대면 진료로 빠르게 처방받아보세요.";
            case "9":
                return "피나스테리드, 두타스테리드 등 탈모약을 병원 방문 없이 닥터나우에서 비대면으로 안전하게 처방받으세요.";
            case "11":
                return "여드름으로 고생하고 있다면? 피부과 방문 없이 닥터나우에서 항생제 및 외용제를 비대면 진료로 처방받아보세요.";
            default:
                return "".concat(this.name, "에 맞는 의사를 빠르게 찾고, 병원 방문 없이 비대면진료로 약 처방까지 받아보세요.");
        }
    };
    _proto.getKeywords = function getKeywords(treatmentId) {
        switch(treatmentId){
            case "1":
                return "감기, 독감, 인후통, 해열제, 비대면 처방";
            case "558":
                return "인공눈물, 안구건조증, 눈 피로, 비대면 진료, 안과 처방, 눈 시림, 눈물약";
            case "9":
                return "탈모약, 피나스테리드, 두타스테리드, 탈모 비대면 처방";
            case "11":
                return "여드름약, 여드름 처방, 피부과 비대면 진료, 항생제";
            default:
                return "비대면진료, 원격진료, 온라인진료, 비대면처방, 약처방, 약배송, 약배달, 진료비";
        }
    };
    (0,_create_class/* default */.Z)(TreatmentCategoryModel, [
        {
            key: "treatments",
            get: function get() {
                var _this = this;
                return this._treatments.map(function(treatment) {
                    return {
                        id: treatment.id,
                        name: treatment.name,
                        getSeoTitle: function() {
                            return _this.getSeoTitle(treatment.id);
                        },
                        getSeoDescription: function() {
                            return _this.getSeoDescription(treatment.id);
                        },
                        getKeywords: function() {
                            return _this.getKeywords(treatment.id);
                        }
                    };
                });
            }
        }
    ]);
    return TreatmentCategoryModel;
}();
var DiagnosisCategoryInfoModel = /*#__PURE__*/ function() {
    "use strict";
    function DiagnosisCategoryInfoModel(popularDepartmentCategories, popularTreatmentCategories, departmentCategories, treatmentCategories) {
        (0,_class_call_check/* default */.Z)(this, DiagnosisCategoryInfoModel);
        this.popularDepartmentCategories = popularDepartmentCategories;
        this.popularTreatmentCategories = popularTreatmentCategories;
        this.departmentCategories = departmentCategories;
        this.treatmentCategories = treatmentCategories;
    }
    var _proto = DiagnosisCategoryInfoModel.prototype;
    _proto.findDepartmentCategoryByCategoryId = function findDepartmentCategoryByCategoryId(categoryId) {
        return this.departmentCategories.find(function(category) {
            return category.id === categoryId;
        }) || null;
    };
    _proto.findTreatmentCategoryByTreatmentId = function findTreatmentCategoryByTreatmentId(treatmentId) {
        return this.treatmentCategories.find(function(category) {
            return category.treatments.some(function(treatment) {
                return treatment.id === treatmentId;
            });
        }) || null;
    };
    _proto.findTreatmentByTreatmentId = function findTreatmentByTreatmentId(treatmentId) {
        var foundCategory = this.findTreatmentCategoryByTreatmentId(treatmentId);
        if (!foundCategory) {
            return null;
        }
        return foundCategory.treatments.find(function(treatment) {
            return treatment.id === treatmentId;
        }) || null;
    };
    _proto.getDepartmentCategories = function getDepartmentCategories() {
        return this.departmentCategories;
    };
    return DiagnosisCategoryInfoModel;
}();

// EXTERNAL MODULE: ./src/types/bff/gql-schema.ts
var gql_schema = __webpack_require__(72271);
;// CONCATENATED MODULE: ./src/hooks/telemedicine/useGetDiagnosisCategories.ts





var parseDiagnosisCategories = function(data) {
    var categoriesInfo = data.getDiagnosisCategoriesV2;
    return new DiagnosisCategoryInfoModel(categoriesInfo.popularDepartmentCategories.map(function(departmentCategory) {
        return new PopularDepartmentCategoryModel(departmentCategory.id, departmentCategory.name);
    }), categoriesInfo.popularTreatmentCategories.map(function(treatmentCategory) {
        return new PopularTreatmentCategoryModel(treatmentCategory.id, treatmentCategory.name);
    }), categoriesInfo.departmentCategories.map(function(departmentCategory) {
        var _description;
        return new DepartmentCategoryModel(departmentCategory.id, departmentCategory.name, (_description = departmentCategory.description) !== null && _description !== void 0 ? _description : "", departmentCategory.iconUrl);
    }), categoriesInfo.treatmentCategories.map(function(treatmentCategory) {
        return new TreatmentCategoryModel(treatmentCategory.id, treatmentCategory.name, treatmentCategory.iconUrl, treatmentCategory.items.map(function(treatment) {
            return {
                id: treatment.id,
                name: treatment.name
            };
        }));
    }));
};
var useGetDiagnosisCategories = function() {
    var ref = (0,telemedicine_gql_impl/* useGetDiagnosisCategoriesV2Query */.lE)({
        contactType: gql_schema/* DiagnosisContactType.NonF2F */.qnl.NonF2F
    }, {
        select: parseDiagnosisCategories
    }), tmp = ref.data, categoriesInfo = tmp === void 0 ? new DiagnosisCategoryInfoModel([], [], [], []) : tmp;
    return {
        categoriesInfo: categoriesInfo
    };
};
/* harmony default export */ var telemedicine_useGetDiagnosisCategories = (useGetDiagnosisCategories);
useGetDiagnosisCategories.getKey = function() {
    return telemedicine_gql_impl/* useGetDiagnosisCategoriesV2Query.getKey */.lE.getKey({
        contactType: gql_schema/* DiagnosisContactType.NonF2F */.qnl.NonF2F
    });
};
useGetDiagnosisCategories.prefetchQuery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(queryClient) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        queryClient.prefetchQuery(useGetDiagnosisCategories.getKey(), telemedicine_gql_impl/* useGetDiagnosisCategoriesV2Query.fetcher */.lE.fetcher({
                            contactType: gql_schema/* DiagnosisContactType.NonF2F */.qnl.NonF2F
                        }))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function(queryClient) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 77196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12436);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_throttle__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78287);
/* harmony import */ var _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10712);






var useCustomRouter = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var moveToPage = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(param) {
        var webLink = param.webLink, mobileScreenName = param.mobileScreenName, params = param.params, as = param.as, _type = param.type, type = _type === void 0 ? _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .NATIVE_POST_MESSAGE_TYPE.MOVE_TO_PAGE */ .nn.MOVE_TO_PAGE : _type;
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .isWebView */ .vp)()) {
            (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .sendPostMessageToNative */ .T0)(type, {
                screenName: mobileScreenName,
                params: params ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, params) : undefined
            });
        } else {
            if (!webLink) return;
            if (type === _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .NATIVE_POST_MESSAGE_TYPE.REPLACE_TO_PAGE */ .nn.REPLACE_TO_PAGE) {
                router.replace(webLink, as);
                return;
            }
            router.push(webLink, as);
        }
    }, [
        router
    ]);
    var getCustomPageName = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(defaultPageName) {
        return (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .isWebView */ .vp)() ? defaultPageName : (0,_utils_logger__WEBPACK_IMPORTED_MODULE_3__/* .getMobileWebPageName */ .b9)(router);
    }, [
        router
    ]);
    var pageName = (0,_utils_logger__WEBPACK_IMPORTED_MODULE_3__/* .getPageName */ .j0)(router);
    return {
        router: router,
        moveToPage: lodash_throttle__WEBPACK_IMPORTED_MODULE_0___default()(moveToPage, 1500, {
            trailing: false
        }),
        getCustomPageName: getCustomPageName,
        pageName: pageName
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useCustomRouter);


/***/ }),

/***/ 89943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ disease_encyclopedia; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/components/atom/BreadCrumbs.tsx
var BreadCrumbs = __webpack_require__(27441);
// EXTERNAL MODULE: ./src/components/layouts/TemplateLayout.tsx
var TemplateLayout = __webpack_require__(75275);
// EXTERNAL MODULE: ./src/constants/zIndex.ts
var zIndex = __webpack_require__(31591);
// EXTERNAL MODULE: ./src/designComponents/organisms/DNSearchBar/index.tsx
var DNSearchBar = __webpack_require__(52477);
// EXTERNAL MODULE: ./src/types/app.ts
var app = __webpack_require__(9912);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(84988);
// EXTERNAL MODULE: ./src/utils/style.ts
var style = __webpack_require__(76666);
// EXTERNAL MODULE: ../../libs/ui/dist/index.es.js
var index_es = __webpack_require__(59950);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/views/disease-encyclopedia/segments/ui/DepartmentButton.tsx



var DepartmentButton = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "".concat(common/* ROUTES.DISEASE_ENCYCLOPEDIA.SEARCH.path */.Z6.DISEASE_ENCYCLOPEDIA.SEARCH.path, "?keyword=").concat(props.name),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: "flex aspect-square flex-col items-center justify-center gap-[12px] overflow-visible",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex h-full w-full items-center justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center justify-center rounded-[18px] bg-gray-20 sm:rounded-[25px] ",
                        style: {
                            padding: "20%"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: props.iconImgSrc,
                            alt: props.name,
                            className: "h-full w-full object-contain"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "typography-ui-13m lg:typography-ui-15m text-clip whitespace-nowrap text-gray-700",
                    children: props.name
                })
            ]
        })
    });
};
/* harmony default export */ var ui_DepartmentButton = (DepartmentButton);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ./src/entities/disease-encyclopedia/util/index.ts
var util = __webpack_require__(1598);
// EXTERNAL MODULE: ./src/shared/ui/content-mark-down/ContentMarkDown.tsx
var ContentMarkDown = __webpack_require__(26324);
;// CONCATENATED MODULE: ./src/views/disease-encyclopedia/segments/ui/PopularDiseaseEncyclopedia.tsx






var PopularDiseaseEncyclopedia = function(props) {
    var ref;
    var ref1, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "grid grid-cols-3 gap-x-[16px] gap-y-[24px] px-[24px] ",
        children: (ref = props.popularDiseaseEncyclopedia) === null || ref === void 0 ? void 0 : ref.map(function(disease) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: (0,util/* createDiseaseEncyclopediaDetailUrl */.$f)(disease),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: "flex flex-col items-start gap-[12px] rounded-[8px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex h-[152px] w-full flex-shrink-0 items-center justify-center overflow-hidden rounded-[8px] bg-gray-30 pr-[38px] pl-[40px]",
                            children: disease.getTitleImageUrl() && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: (ref1 = disease.getTitleImageUrl()) !== null && ref1 !== void 0 ? ref1 : undefined,
                                alt: disease.getTitle(),
                                className: "h-[152px] w-[152px] object-cover"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col text-left",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "typography-ui-17sb mb-1 line-clamp-1 overflow-ellipsis text-gray-900",
                                    children: disease.getTitle()
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "typography-ui-15m line-clamp-2 h-[44px] overflow-ellipsis text-left text-gray-400",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentMarkDown/* default */.Z, {
                                        markdown: (ref2 = disease.getContent()) !== null && ref2 !== void 0 ? ref2 : "",
                                        components: {
                                            h2: function(_node) {
                                                for(var _len = arguments.length, _rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                                                    _rest[_key - 1] = arguments[_key];
                                                }
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                                            },
                                            h3: function(_node) {
                                                for(var _len = arguments.length, _rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                                                    _rest[_key - 1] = arguments[_key];
                                                }
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                                            },
                                            h4: function(_node) {
                                                for(var _len = arguments.length, _rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                                                    _rest[_key - 1] = arguments[_key];
                                                }
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                                            },
                                            p: function(node) {
                                                for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                                                    rest[_key - 1] = arguments[_key];
                                                }
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
                                                    children: node.children
                                                }));
                                            }
                                        }
                                    })
                                })
                            ]
                        })
                    ]
                })
            }, "disease-encyclopedia-".concat(disease.getPublicId()));
        })
    });
};
/* harmony default export */ var ui_PopularDiseaseEncyclopedia = (PopularDiseaseEncyclopedia);

// EXTERNAL MODULE: ../../node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(57506);
;// CONCATENATED MODULE: ./src/views/disease-encyclopedia/segments/ui/PopularDiseaseEncyclopediaSwiper.tsx





var PopularDiseaseEncyclopediaSwiper = function(props) {
    var ref;
    var ref1, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
        slidesPerView: "auto",
        spaceBetween: 16,
        style: {
            paddingLeft: 24,
            paddingRight: 24
        },
        children: (ref = props.popularDiseaseEncyclopedia) === null || ref === void 0 ? void 0 : ref.map(function(disease) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                style: {
                    width: "fit-content"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    className: "flex w-[230px] flex-col items-start gap-[12px] rounded-[8px]",
                    onClick: props.onClick(disease),
                    type: "button",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex h-[152px] w-[230px] flex-shrink-0 items-center justify-center overflow-hidden rounded-[8px] bg-gray-30 pr-[38px] pl-[40px]",
                            children: disease.getTitleImageUrl() && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: (ref1 = disease.getTitleImageUrl()) !== null && ref1 !== void 0 ? ref1 : undefined,
                                alt: disease.getTitle(),
                                className: "h-[152px] w-full object-cover"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col text-left",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "typography-ui-17sb mb-1 line-clamp-1 overflow-ellipsis text-gray-900",
                                    children: disease.getTitle()
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "typography-ui-15m line-clamp-2 h-[44px] overflow-ellipsis text-left text-gray-400",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentMarkDown/* default */.Z, {
                                        markdown: (ref2 = disease.getContent()) !== null && ref2 !== void 0 ? ref2 : "",
                                        components: {
                                            h2: function(_node) {
                                                for(var _len = arguments.length, _rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                                                    _rest[_key - 1] = arguments[_key];
                                                }
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                                            },
                                            h3: function(_node) {
                                                for(var _len = arguments.length, _rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                                                    _rest[_key - 1] = arguments[_key];
                                                }
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                                            },
                                            h4: function(_node) {
                                                for(var _len = arguments.length, _rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                                                    _rest[_key - 1] = arguments[_key];
                                                }
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                                            },
                                            p: function(node) {
                                                for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                                                    rest[_key - 1] = arguments[_key];
                                                }
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
                                                    children: node.children
                                                }));
                                            }
                                        }
                                    })
                                })
                            ]
                        })
                    ]
                }, disease.getPublicId())
            }, disease.getPublicId());
        })
    });
};
/* harmony default export */ var ui_PopularDiseaseEncyclopediaSwiper = (PopularDiseaseEncyclopediaSwiper);

;// CONCATENATED MODULE: ./src/views/disease-encyclopedia/segments/ui/TotalIcon.tsx

var TotalIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        className: "".concat(props.className),
        viewBox: "0 0 51 52",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                y: "0.5",
                width: "51",
                height: "51",
                fill: "url(#pattern0_2140_32404)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("pattern", {
                        id: "pattern0_2140_32404",
                        patternContentUnits: "objectBoundingBox",
                        width: "1",
                        height: "1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                            xlinkHref: "#image0_2140_32404",
                            transform: "scale(0.00970874)"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("image", {
                        id: "image0_2140_32404",
                        width: "103",
                        height: "103",
                        preserveAspectRatio: "none",
                        xlinkHref: "data:image/png;base64,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"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ui_TotalIcon = (TotalIcon);

;// CONCATENATED MODULE: ./src/views/disease-encyclopedia/segments/ui/TotalDepartmentButton.tsx




var TotalDepartmentButton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: common/* ROUTES.DISEASE_ENCYCLOPEDIA.TOTAL.path */.Z6.DISEASE_ENCYCLOPEDIA.TOTAL.path,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: "flex aspect-square flex-col items-center justify-center gap-[12px] overflow-visible",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex h-full w-full items-center justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center justify-center rounded-[18px] bg-gray-20 sm:rounded-[25px]",
                        style: {
                            padding: "20%"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_TotalIcon, {
                            className: "h-full w-full object-contain"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "typography-ui-13m lg:typography-ui-15m text-gray-700",
                    children: "전체보기"
                })
            ]
        })
    });
};
/* harmony default export */ var ui_TotalDepartmentButton = (TotalDepartmentButton);

;// CONCATENATED MODULE: ./src/views/disease-encyclopedia/segments/ui/DiseaseEncyclopediaView.tsx
















var DiseaseEncyclopediaView = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Wrapper */.Z.Wrapper, {
        children: [
            props.client.clientType === app/* ClientType.WEB */.B.WEB && /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default.Wrapper */.Z.Wrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default */.Z, {
                    visible: true,
                    name: "질환백과",
                    type: "disease_encyclopedia",
                    path: "".concat(common/* ROUTES.DISEASE_ENCYCLOPEDIA.HOME.path */.Z6.DISEASE_ENCYCLOPEDIA.HOME.path)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "typography-ui-22sb px-[24px] py-[16px] text-gray-900",
                children: "질환백과"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-[24px] py-[16px]",
                style: {
                    zIndex: zIndex/* zIndex.AppHeader */.W.AppHeader,
                    top: props.client.clientType === app/* ClientType.MOBILE_WEB */.B.MOBILE_WEB ? "60px" : "0px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DNSearchBar/* default */.Z, {
                    value: props.viewModel.keyword,
                    placeholder: "질환 이름 혹은 증상 검색",
                    shouldShowResetButton: !!props.viewModel.keyword,
                    onSubmit: props.viewModel.handleSubmit,
                    onReset: props.viewModel.handleResetSearchKeyword,
                    onChange: props.viewModel.handleChangeSearchKeyword
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-[24px] pt-[4px] pb-[32px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "typography-ui-20sb mb-5 text-gray-700",
                        children: "과목으로 찾기"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,style.cn)("grid grid-rows-2", props.client.isMobile ? "grid-cols-4" : "grid-cols-7", props.client.isMobile ? "gap-[16px]" : "gap-[20px]"),
                        children: [
                            props.viewModel.departmentCategories.map(function(departmentCategory) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_DepartmentButton, {
                                    iconImgSrc: departmentCategory.icon,
                                    name: departmentCategory.name,
                                    onClick: props.viewModel.onClickDiseaseEncyclopedia(departmentCategory)
                                }, departmentCategory.id);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_TotalDepartmentButton, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-[16px] bg-gray-30"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pt-[32px] pb-[80px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-[20px] flex items-center gap-[4px] px-[24px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "typography-ui-20sb text-gray-700",
                            children: "많이 찾는 질환"
                        })
                    }),
                    props.client.isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_PopularDiseaseEncyclopediaSwiper, {
                        popularDiseaseEncyclopedia: props.viewModel.popularDiseaseEncyclopedia,
                        onClick: props.viewModel.handleClickPopularDisease
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_PopularDiseaseEncyclopedia, {
                        popularDiseaseEncyclopedia: props.viewModel.popularDiseaseEncyclopedia,
                        onClick: props.viewModel.handleClickPopularDisease
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center px-[24px] pt-[24px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: common/* ROUTES.DISEASE_ENCYCLOPEDIA.TOTAL.path */.Z6.DISEASE_ENCYCLOPEDIA.TOTAL.path,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                    buttonStyle: "outlined",
                                    buttonColor: "gray",
                                    size: "xl",
                                    className: "w-full",
                                    children: "질환 전체 보기"
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ui_DiseaseEncyclopediaView = (DiseaseEncyclopediaView);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ./src/hooks/telemedicine/useGetDiagnosisCategories.ts + 1 modules
var useGetDiagnosisCategories = __webpack_require__(60643);
// EXTERNAL MODULE: ./src/hooks/useCustomRouter.tsx
var useCustomRouter = __webpack_require__(77196);
// EXTERNAL MODULE: ./src/entities/disease-encyclopedia/model/diseaseEncyclopedia.ts
var model_diseaseEncyclopedia = __webpack_require__(18103);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(36492);
// EXTERNAL MODULE: ./src/utils/fetcher.ts
var fetcher = __webpack_require__(8391);
;// CONCATENATED MODULE: ./src/views/disease-encyclopedia/segments/hooks/disease-encyclopedia.gql.impl.tsx


var GetPopularDiseaseEncyclopediasDocument = "\n    query GetPopularDiseaseEncyclopedias($limit: Int!) {\n  popularDiseaseEncyclopedias(limit: $limit) {\n    content\n    title\n    titleImageUrl\n    publicId\n  }\n}\n    ";
var useGetPopularDiseaseEncyclopediasQuery = function(variables, options) {
    return (0,useQuery/* useQuery */.a)([
        "GetPopularDiseaseEncyclopedias",
        variables
    ], (0,fetcher/* gqlFetcher */.l3)(GetPopularDiseaseEncyclopediasDocument, "GetPopularDiseaseEncyclopedias", variables), options);
};
useGetPopularDiseaseEncyclopediasQuery.getKey = function(variables) {
    return [
        "GetPopularDiseaseEncyclopedias",
        variables
    ];
};
useGetPopularDiseaseEncyclopediasQuery.fetcher = function(variables, options) {
    return (0,fetcher/* gqlFetcher */.l3)(GetPopularDiseaseEncyclopediasDocument, "GetPopularDiseaseEncyclopedias", variables, options);
};

;// CONCATENATED MODULE: ./src/views/disease-encyclopedia/segments/hooks/useGetPopularDiseaseEncyclopedias.ts


var parseDiseaseEncyclopedia = function(data) {
    if (data) {
        return data.popularDiseaseEncyclopedias.map(function(diseaseEncyclopedia) {
            var _titleImageUrl;
            return new model_diseaseEncyclopedia/* default */.ZP({
                publicId: diseaseEncyclopedia.publicId,
                title: diseaseEncyclopedia.title,
                titleImageUrl: (_titleImageUrl = diseaseEncyclopedia.titleImageUrl) !== null && _titleImageUrl !== void 0 ? _titleImageUrl : undefined,
                content: diseaseEncyclopedia.content
            });
        });
    }
    return [];
};
var DISEASE_ENCYCLOPEDIA_SIZE = 6;
var useGetPopularDiseaseEncyclopedias = function() {
    var ref = useGetPopularDiseaseEncyclopediasQuery({
        limit: DISEASE_ENCYCLOPEDIA_SIZE
    }, {
        select: parseDiseaseEncyclopedia
    }), popularDiseaseEncyclopedia = ref.data, isPopularDiseaseEncyclopediaLoading = ref.isLoading;
    return {
        popularDiseaseEncyclopedia: popularDiseaseEncyclopedia,
        isPopularDiseaseEncyclopediaLoading: isPopularDiseaseEncyclopediaLoading
    };
};
/* harmony default export */ var hooks_useGetPopularDiseaseEncyclopedias = (useGetPopularDiseaseEncyclopedias);
useGetPopularDiseaseEncyclopedias.prefetchQuery = function(queryClient) {
    return queryClient.prefetchQuery(useGetPopularDiseaseEncyclopediasQuery.getKey({
        limit: DISEASE_ENCYCLOPEDIA_SIZE
    }), useGetPopularDiseaseEncyclopediasQuery.fetcher({
        limit: DISEASE_ENCYCLOPEDIA_SIZE
    }));
};

;// CONCATENATED MODULE: ./src/views/disease-encyclopedia/segments/hooks/useDiseaseEncyclopediaViewModel.ts







var MOBILE_DEPARTMENT_CATEGORIES_LIMIT = 7;
var DESKTOP_DEPARTMENT_CATEGORIES_LIMIT = 13;
var useDiseaseEncyclopediaViewModel = function(props) {
    var router = (0,useCustomRouter/* default */.Z)().router;
    var ref = (0,react.useState)(""), keyword = ref[0], setKeyword = ref[1];
    var handleSubmit = function() {
        var searchKeyword = keyword.trim();
        if (searchKeyword) {
            router.replace({
                pathname: common/* ROUTES.DISEASE_ENCYCLOPEDIA.SEARCH.path */.Z6.DISEASE_ENCYCLOPEDIA.SEARCH.path,
                query: {
                    keyword: searchKeyword
                }
            });
        }
    };
    var handleResetSearchKeyword = function() {
        setKeyword("");
    };
    var categoriesInfo = (0,useGetDiagnosisCategories/* default */.Z)().categoriesInfo;
    var departmentCategories = (0,_to_consumable_array/* default */.Z)(categoriesInfo.getDepartmentCategories().sort(function(prev, next) {
        return prev.name.localeCompare(next.name);
    })).slice(0, props.client.isMobile ? MOBILE_DEPARTMENT_CATEGORIES_LIMIT : DESKTOP_DEPARTMENT_CATEGORIES_LIMIT);
    var popularDiseaseEncyclopedia = hooks_useGetPopularDiseaseEncyclopedias().popularDiseaseEncyclopedia;
    var onClickDiseaseEncyclopedia = function(departmentCategory) {
        return function() {
            router.push("".concat(common/* ROUTES.DISEASE_ENCYCLOPEDIA.SEARCH.path */.Z6.DISEASE_ENCYCLOPEDIA.SEARCH.path, "?keyword=").concat(departmentCategory.name));
        };
    };
    var handleChangeSearchKeyword = function(e) {
        setKeyword(e.target.value);
    };
    var onClickShowAllDepartment = function() {
        router.push(common/* ROUTES.DISEASE_ENCYCLOPEDIA.SELECT_SUBJECT.path */.Z6.DISEASE_ENCYCLOPEDIA.SELECT_SUBJECT.path);
    };
    var handleClickPopularDisease = function(disease) {
        return function() {
            router.push("".concat((0,util/* createDiseaseEncyclopediaDetailUrl */.$f)(disease)));
        };
    };
    var onClickShowAllDiseases = function() {
        router.push(common/* ROUTES.DISEASE_ENCYCLOPEDIA.TOTAL.path */.Z6.DISEASE_ENCYCLOPEDIA.TOTAL.path);
    };
    return {
        departmentCategories: departmentCategories,
        keyword: keyword,
        popularDiseaseEncyclopedia: popularDiseaseEncyclopedia,
        handleResetSearchKeyword: handleResetSearchKeyword,
        handleSubmit: handleSubmit,
        onClickDiseaseEncyclopedia: onClickDiseaseEncyclopedia,
        handleChangeSearchKeyword: handleChangeSearchKeyword,
        onClickShowAllDepartment: onClickShowAllDepartment,
        handleClickPopularDisease: handleClickPopularDisease,
        onClickShowAllDiseases: onClickShowAllDiseases
    };
};
/* harmony default export */ var hooks_useDiseaseEncyclopediaViewModel = (useDiseaseEncyclopediaViewModel);

;// CONCATENATED MODULE: ./src/views/disease-encyclopedia/index.ts



// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
;// CONCATENATED MODULE: ./src/pages/disease-encyclopedia/index.tsx
// PageDescription: 질환백과 리스트 페이지



var DiseaseEncyclopediaPage = function(param) {
    var client = param.client;
    var viewModel = hooks_useDiseaseEncyclopediaViewModel({
        client: client
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "닥터나우 질환백과 - 모든 질병의 증상, 원인, 치료 정보",
                description: "감기부터 대상포진까지 모든 질병의 원인, 증상, 치료법, 주의사항을 닥터나우 질환백과에서 확인해보세요."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_DiseaseEncyclopediaView, {
                viewModel: viewModel,
                client: client
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var disease_encyclopedia = (DiseaseEncyclopediaPage);


/***/ }),

/***/ 26324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91650);
/* harmony import */ var rehype_raw__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35082);
/* harmony import */ var remark_breaks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51981);
/* harmony import */ var remark_gfm__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20570);





var ContentMarkDown = function(param) {
    var markdown = param.markdown, components = param.components;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_markdown__WEBPACK_IMPORTED_MODULE_1__/* .ReactMarkdown */ .D, {
        rehypePlugins: [
            rehype_raw__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z
        ],
        remarkPlugins: [
            remark_gfm__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
            remark_breaks__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z
        ],
        components: components,
        children: markdown
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentMarkDown);


/***/ }),

/***/ 45162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Tq": function() { return /* binding */ AuthorType; },
/* harmony export */   "Zg": function() { return /* binding */ MagazineTagType; },
/* harmony export */   "pO": function() { return /* binding */ EDoctorCareer; },
/* harmony export */   "rL": function() { return /* binding */ MagazineType; },
/* harmony export */   "wK": function() { return /* binding */ MagazineBottomButtonType; }
/* harmony export */ });
/* unused harmony export CoreCategoryType */
var MagazineType = {
    INTERNAL: "INTERNAL",
    EXTERNAL: "EXTERNAL",
    ARTICLE: "ARTICLE",
    FAQ: "FAQ"
};
var MagazineTagType;
(function(MagazineTagType) {
    MagazineTagType["DEPARTMENT"] = "DEPARTMENT";
    MagazineTagType["SYMPTOM"] = "SYMPTOM";
    MagazineTagType["DISEASE"] = "DISEASE";
    MagazineTagType["FREE"] = "FREE";
})(MagazineTagType || (MagazineTagType = {}));
var CoreCategoryType;
(function(CoreCategoryType) {
    CoreCategoryType["Department"] = "DEPARTMENT";
    CoreCategoryType["Disease"] = "DISEASE";
    CoreCategoryType["Symptom"] = "SYMPTOM";
})(CoreCategoryType || (CoreCategoryType = {}));
var AuthorType;
(function(AuthorType) {
    AuthorType["DOCTOR"] = "DOCTOR";
    AuthorType["AI"] = "AI";
    AuthorType["NURSE"] = "NURSE";
    AuthorType["MEDICAL_PROFESSIONAL_EDITOR"] = "MEDICAL_PROFESSIONAL_EDITOR";
    AuthorType["GENERAL_EDITOR"] = "GENERAL_EDITOR";
})(AuthorType || (AuthorType = {}));
var ProfessionalFieldType;
(function(ProfessionalFieldType) {
    ProfessionalFieldType["DEPARTMENT"] = "DEPARTMENT";
})(ProfessionalFieldType || (ProfessionalFieldType = {}));
var MagazineBottomButtonType;
(function(MagazineBottomButtonType) {
    MagazineBottomButtonType["QUESTION"] = "QUESTION";
    MagazineBottomButtonType["DIAGNOSIS"] = "DIAGNOSIS";
})(MagazineBottomButtonType || (MagazineBottomButtonType = {}));
var EDoctorCareer;
(function(EDoctorCareer) {
    EDoctorCareer["CURRENT"] = "CURRENT";
    EDoctorCareer["PAST"] = "PAST";
    EDoctorCareer["GRADUATION"] = "GRADUATION";
    EDoctorCareer["COMPLETION"] = "COMPLETION";
})(EDoctorCareer || (EDoctorCareer = {}));


/***/ }),

/***/ 76666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cn": function() { return /* binding */ cn; }
/* harmony export */ });
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40489);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98388);


function cn() {
    for(var _len = arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++){
        inputs[_key] = arguments[_key];
    }
    return (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_0__/* .twMerge */ .m6)((0,clsx__WEBPACK_IMPORTED_MODULE_1__/* .clsx */ .W)(inputs));
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1498,7506,2498,6225,9774,2888,179], function() { return __webpack_exec__(98041); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);